import i18next from 'i18next';

i18next.addResources('en', 'technology', {
  HERO_TITLE: 'Pushing coach\n expertise\n to its highest\n power',
  HERO_TITLE_TABLET: 'Pushing\n coach\n expertise\n to its \nhighest',
  VISION_TITLE_1: 'Pivot Vision \nempowers',
  VISION_CONTENT_1:
    'Your coaches. Your technique. And your workout through a 3D sensor equipped with advanced A.I. that captures your real-time performance to craft workouts that cater to you.',
  VISION_TITLE_2: 'Focused \non motion',
  VISION_CONTENT_2:
    'Pivot Vision captures movement through a combination of depth and RGB perception. From that, it isolates pivot points on your body to accurately count your reps, measure your pace, and note your form.',
  MOVEMENT_STATEMENT_TITLE: '25 Points of \nMovement',
  MOVEMENT_STATEMENT_SUBTITLE_1: 'Meticulous measurements',
  MOVEMENT_STATEMENT_CONTENT_1:
    'Pivot Vision doesn’t miss a second of your workout.\nIt scans your body 30x a second, generating 80,000 data points to analyze, that we then pare down to the 25 essential pivot points. It also excels for every body type, in any kind of clothing you’re comfortable working out in.',
  MOVEMENT_STATEMENT_SUBTITLE_2: 'Know \nto grow',
  MOVEMENT_STATEMENT_CONTENT_2:
    'Our meticulous measurements are translated into easy to grasp coaching notes, including rep counts and form feedback. It excels for every body type, in any kind of clothing you’re comfortable working out in.',
  MOVEMENT_STATEMENT_IMG: 'Pivot movement feedback',
  COACHES_TITLE_1: 'Coaches \nwho really \ncoach',
  COACHES_CONTENT_1:
    'Through Pivot Vision, our coaches are never just projections on a beautiful screen. Pivot Vision powerfully collaborates with them, giving coaches the ability to work with you individually, from your living room.',
  COACHES_TITLE_2: 'Privacy is \nparamount',
  COACHES_CONTENT_2:
    'We hold your privacy as seriously as we hold Pivot’s ability to power your fitness goals. Pivot Vision only sees your body as unrecognizable greyscale and does not capture any interiors of your home.'
});
